import Swiper from 'swiper';
const { animate, stagger, scroll } = Motion;
//import 'swiper/css';

// Make Swiper available globally for other scripts
window.Swiper = Swiper;

// Utility function to check if device is mobile (viewport width < 768px)
function isMobile() {
    return window.innerWidth < 768;
}

// Get container width based on viewport (Bootstrap 5 breakpoints)
function getContainerWidth() {
    const vw = window.innerWidth;
    if (vw >= 1400) return 1340;
    if (vw >= 1200) return 1140;
    if (vw >= 992) return 930;
    if (vw >= 768) return 720;
    if (vw >= 576) return 540;
    return vw;
}

jQuery(document).ready(function ($) {

    console.log("main.js loaded");
    // share url on click
    jQuery("input.js-copy-click").on("click", function () {
        $(this).focus();
        $(this).select();
        document.execCommand("copy");
        jQuery(".js-copy-notice").fadeIn().delay(3000).fadeOut();
    });

    // change link before default click happens
    jQuery(".request-link").on("click", function (event) {
        // Save offer request link without param
        var requestLink = jQuery(this).attr("href");

        // Build paramURL from li.active in bottle configurator
        var requestParam = "?";
        jQuery("div#bottle-options-js")
            .find(".active,.swiper-slide-active")
            .each(function (i, obj) {
                requestParam += jQuery(this).data("field") + "=" + jQuery(this).data("value") + "&";

                if (jQuery(this).data("field2")) {
                    requestParam += jQuery(this).data("field2") + "=" + jQuery(this).data("value2") + "&";
                }
            });

        window.location.href = requestLink + requestParam;
        event.preventDefault();
    });

    // Sticky header, not in use
    /*
    jQuery(window).scroll(function() {
        var header = jQuery('body > header');
        var scrollspace = jQuery(window).scrollTop();

        if (scrollspace > 0) {
            if (!header.hasClass('shadow')) {
                header.addClass('shadow');
            }
        } else {
            if (header.hasClass('shadow')) {
                header.removeClass('shadow');
            }
        }

        if (scrollspace > 300) {
            if (!header.hasClass('sticky')) {
                header.addClass('sticky');
            }
        } else {
            if (header.hasClass('sticky')) {
                header.removeClass('sticky');
            }
        }
    });
    &/



    /* js/modules/panels.js */

    // attribute panels
    $(".panel-link").on("click", function () {
        event.preventDefault();
        $("body").css("overflow", "hidden");

        $(".cd-panel-content div").html($(this).data("content"));
        $(".cd-panel-content h2").html($(this).data("title"));
        $(".cd-panel .cd-panel-image").css("background-image", "url(" + $(this).data("image") + ")");

        $(".cd-panel").addClass("is-visible");
    });

    // panels
    $(".block-item[data-id]")
        .not(".block-video")
        .on("click", function (event) {
            event.preventDefault();
            var dataid = $(this).data("id");
            $("body").css("overflow", "hidden");
            $(".cd-panel[data-id=item-" + dataid + "]").addClass("is-visible");
        });

    $(".cd-panel").on("click", function (event) {
        if ($(event.target).is(".cd-panel") || $(event.target).is(".close-icon")) {
            $("body").css("overflow", "auto");

            $panel = $(this);
            $panel.addClass("anim-out");

            setTimeout(function () {
                $panel.hide();
                $(".cd-panel").removeClass("is-visible");
                $(".cd-panel").removeClass("anim-out");

                $("body").css("overflow", "auto");
            }, 1000);

            setTimeout(function () {
                $panel.show();
            }, 2000);

            event.preventDefault();
        }
    });

    // check hash and open panel
    var panelid = window.location.hash.substr(1);
    panelid = panelid.replace(/[^\w\s]/gi, "");
    if (panelid) {
        if ($(".cd-panel[data-id=item-" + panelid + "]").length > 0) {
            $("body").css("overflow", "hidden");
            $(".cd-panel[data-id=item-" + panelid + "]").addClass("is-visible");
        }
    }

    /* /js/modules/panels.js */

    //move to top button
    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = $(".cd-top"),
        $product_bar = $(".product-fixed-bar");

    //smooth scroll to top
    $back_to_top.on("click", function (event) {
        event.preventDefault();
        $("body,html").animate(
            {
                scrollTop: 0,
            },
            scroll_top_duration
        );
    });

    //main menu animation
    $(".main-nav-button").click(function (event) {
        $("body").toggleClass("navmenu");
        $(".main_menu_bg").toggleClass("active");
        $("nav.wp_nav_main_menu").toggleClass("active");
        $(this).toggleClass("active");

        event.preventDefault();
        //return false;
    });

    $("#dl-menu ul.sub-menu").each(function () {
        $(this).addClass("dl-submenu");
    });

    $('[data-toggle="tooltip"]').tooltip();

    $("#dl-menu").dlmenu({
        animationClasses: {
            classin: "dl-animate-in-1",
            classout: "dl-animate-out-1",
        },
    });

    //Close menu when clicking outside of it.
    var mouse_is_inside_menu = false;
    $(".main_menu_bg, .header-top").mouseenter(function () {
        mouse_is_inside_menu = true;
    });
    $(".main_menu_bg, .header-top").mouseleave(function () {
        mouse_is_inside_menu = false;
    });
    // Detect normal click
    $(document).mouseup(function () {
        if (!mouse_is_inside_menu && $(".main_menu_bg").hasClass("active")) {
            $(".main-nav-button").trigger("click");
        }
    });
    // Dectect iframe click
    window.addEventListener("blur", function () {
        if (!mouse_is_inside_menu && $(".main_menu_bg").hasClass("active")) {
            $(".main-nav-button").trigger("click");
        }
    });

    // ancher tag scroll to
    $("#anchor-links a[href*='#']").click(function (e) {
        e.preventDefault();
        var dest = $(this).attr("href");
        $("html,body").animate({ scrollTop: $(dest).offset().top, easing: "easein" }, "slow");
    });

    //custom active menu item
    var currentMenuItem = $("#dl-menu .current-menu-item");
    if (currentMenuItem.length > 0) {
        currentMenuItem.parents("li").each(function () {
            if (!$(this).hasClass("current-menu-ancestor")) {
                $(this).addClass("current-menu-ancestor");
            }
        });
    }

    // Trigger clicks to open menu on current page
    var liCurrentMenu = $("#dl-menu .current-menu-ancestor");
    if (liCurrentMenu.length > 0) {
        var i = 0;
        var fn = function () {
            var element = $(liCurrentMenu[i]);
            $(liCurrentMenu[i]).find("a").first().trigger("click");

            if (++i < liCurrentMenu.length) {
                setTimeout(fn, 200);
            }
        };
        fn();
    }

    //hide or show the "back to top" link
    $(window).scroll(function () {
        if ($(this).scrollTop() > offset) {
            $back_to_top.addClass("cd-is-visible");
        } else {
            $back_to_top.removeClass("cd-is-visible cd-fade-out");
        }

        if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass("cd-fade-out");
        }

        if ($(this).scrollTop() > 10) {
            $product_bar.addClass("fill-bar");
        } else {
            $product_bar.removeClass("fill-bar");
        }

        // Add bg-color class to desktop-header when scrolling with transparent-menu
        if ($("body").hasClass("transparent-menu")) {
            if ($(this).scrollTop() > 300) {
                $(".desktop-header").addClass("bg-color");
            } else {
                $(".desktop-header").removeClass("bg-color");
            }
        }
    });

jQuery("#mute_toggle").on("click", function (e) {
        var mute_toggle = jQuery(this);
        e.preventDefault();

        if (player.isMuted()) {
            player.unMute();
            mute_toggle.html('<i class="fa fa-volume-up" aria-hidden="true"></i>');
        } else {
            player.mute();
            mute_toggle.html('<i class="fa fa-volume-off" aria-hidden="true"></i>');
        }
    });

    //hide collapsed items
    $(document).on("click", function (event) {
        var clickover = $(event.target);
        if (clickover.hasClass("variations_fold") || clickover.parents(".variations_fold").length) {
            var _currentWrapper = true;
        }
        var navbar = $(".variations_fold");
        var _opened = navbar.hasClass("in");
        if (_opened === true && _currentWrapper !== true) {
            navbar.collapse("hide");
            jQuery("a.open_variations").addClass("collapsed");
            //$("a.open_variations").addClass('collapsed')
        }
    });

    var $activeMenuDrop = "";
    var $activeMenuItem = "";

    //top menu dropdowns
    $(".language-btn-toggle").click(function () {
        $($activeMenuDrop).removeClass("active");
        if ($activeMenuItem.length) {
            $activeMenuItem.removeClass("active");
            $activeMenuItem.closest(".topnav").removeClass("active");
        }

        if ($(this).is($activeMenuItem)) {
            $(".lang-selector-dropdown").removeClass("active");
            $(this).closest(".topnav").removeClass("active");
            $(this).removeClass("active");
            $activeMenuDrop = "";
            $activeMenuItem = "";
        } else {
            $(".lang-selector-dropdown").addClass("active");
            $(this).closest(".topnav").addClass("active");
            $(this).addClass("active");
            $activeMenuDrop = ".lang-selector-dropdown";
            $activeMenuItem = $(this);
        }

        return false;
    });

    $(".search-show-toggle").click(function () {
        $($activeMenuDrop).removeClass("active");
        if ($activeMenuItem.length) {
            $activeMenuItem.removeClass("active");
            $activeMenuItem.closest(".topnav").removeClass("active");
        }

        if ($(this).is($activeMenuItem)) {
            $(".searchbar-dropdown").removeClass("active");
            $(this).closest(".topnav").removeClass("active");
            $(this).removeClass("active");
            $activeMenuDrop = "";
            $activeMenuItem = "";
        } else {
            $(".searchbar-dropdown").addClass("active");
            $(this).closest(".topnav").addClass("active");
            $(this).addClass("active");
            $activeMenuDrop = ".searchbar-dropdown";
            $activeMenuItem = $(this);
        }

        return false;
    });

    $(document).click(function (event) {
        if (!$(event.target).closest("#cart-dropdown").length) {
            if ($("#cart-dropdown").hasClass("active")) {
                cartDropdownToggle();
            }
        }
    });

    // Add glyphicon to language menu
    $("#lang-selector-lang .wpml-ls > ul > li > a").append('<i class="glyphicon glyphicon-chevron-down"></i>');

    // Productbar anchor links
    $("#anchor_button").click(function () {
        $("#anchor-links").toggleClass("on");
    });

    if ($(".swiper-block-container").length > 0) {
        $(".swiper-block-container").each(function () {
            var swiper_id = $(this).attr("id");

            var swiperSlider = new Swiper("#" + swiper_id, {
                pagination: {
                    el: "#swiper-pagination-" + swiper_id,
                    type: "bullets",
                    clickable: true,
                },
                autoplay: {
                    delay: 4000,
                },
                speed: 500,
                loop: true,
            });
        });
    }

    if ($(".swiper-block-header").length > 0) {
        var headerSlider = new Swiper(".swiper-block-header", {
            autoplay: {
                delay: 4000,
            },
            speed: 500,
            loop: true,
        });
    }

    // Build 1
    if (jQuery(".swiper-container:not(.bottle-swiper)").length) {
        var TacxSwiper = [];
        var count = 0;
        jQuery(".swiper-container").each(function () {
            var useAutoheight = false;
            if (jQuery(".swiper-container").find(".swiper_autoheight").length != 0) {
                useAutoheight = true;
            }
            count++;
            var swiperId = $(this).attr("id");
            TacxSwiper[count] = new Swiper(jQuery("#" + swiperId), {
                loop: true,
                autoHeight: useAutoheight,
                navigation: {
                    prevEl: "#prev-" + swiperId + ".swiper-button-prev",
                    nextEl: "#next-" + swiperId + ".swiper-button-next",
                },
                // effect: 'fade',
                // autoplay: 4000,
            });
        });
    }

    /*
    if (jQuery('.swiper-home').length) {
        jQuery('.swiper-home').each(function () {

            var TacxSwiper = new Swiper(this, {
                mode: 'horizontal',
                useCSS3Transforms: false,
                loop: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                autoplay: 4000,
                lazyLoading: true
            });
        });
    }

*/
    var windowwidth = $(window).width();
    $(window).resize(function () {
        var windowwidth = $(window).width();
        resize_product_headers();
        resize_card_cols();
    });

    // Build swiper
    if (windowwidth < 767) {
        $(".swiper-container-xs").each(function () {
            var TacxProductSwiper = new Swiper(this, {
                loop: true,
                navigation: {
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next",
                },
                wrapperClass: "swiper-wrapper-xs",
                autoplay: {
                    delay: 4000,
                },
            });
        });
    }

    jQuery(".image-container").each(function () {
        var height = jQuery(this).find(".image-bottle-slider").outerHeight();
        jQuery(this).height(height);
    });

    function resize_product_headers() {
        var product_header_height = 0;
        jQuery("section.blocks.product-overview .block-header-inner")
            .height("auto")
            .each(function () {
                var height = jQuery(this).outerHeight();
                if (height > product_header_height) product_header_height = height;
            })
            .height(product_header_height);
    }
    resize_product_headers();

    function resize_card_cols() {
        var card_col_height = 0;
        jQuery("section.plain-content-with-image .featured-info")
            .height("auto")
            .each(function () {
                var height = jQuery(this).height();
                if (height > card_col_height) card_col_height = height;
            })
            .height(card_col_height);
    }
    resize_card_cols();

    // $(window).on("scroll", function () {
    // 	$(".desktop-header .header-wrapper ul li").addClass("no-hover");

    // 	if ($(window).scrollTop() == 0) {
    // 		$(".desktop-header .header-wrapper ul li").removeClass("no-hover");
    // 	}
    // });

    //use when checkout is updated
    /*$(document.body).on('updated_checkout', function () {
        $('#shipping_method li').each(function (e) {
            if ($(this).children('input').is(':checked')) {
                $(this).children('.shipping_box').show();
            }
        });

        var checked = $("input#terms:checked").length;
        if (checked == 0) {
            $('input#place_order').prop('disabled', true);
        } else {
            $('#order_note').hide();
        }

        $("input#terms").change(function () {
            if (this.checked) {
                $('input#place_order').prop('disabled', false);
                $('#order_note').hide();
            } else {
                $('input#place_order').prop('disabled', true);
                $('#order_note').show();
            }
        });
    });*/

    /*$('.swiper-container-cages').each(function () {
        var slides = $(this).find('.swiper-slide').length;
        var centerSlide = Math.round(slides / 2) - 1;

        var TacxCageSwiper = new Swiper(this, {
            slidesPerView: 6,
            spaceBetween: 40,
            mode: 'horizontal',
            useCSS3Transforms: false,
            prevButton: '.swiper-cages-button-prev',
            nextButton: '.swiper-cages-button-next',

            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 10
                },
                768: {
                    slidesPerView: 3,
                    spaceBetweenSlides: 20
                },
                992: {
                    slidesPerView: 4,
                    spaceBetweenSlides: 30
                }
            }
        });

    });*/

    // where to buy page
    /*if ($('#countries').length != 0) {
        $("#countries").select2({
            minimumResultsForSearch: Infinity
        });
    }
    if ($('#wpsl-radius').length != 0) {
        $("#wpsl-radius").ionRangeSlider({
            min: 0,
            max: 1000,
            onFinish: function (data) {
                //console.log("onFinish", data.from);
                $("#wpsl-radius").attr('value', data.from);
            },
        });
    }

    // simple tooltip where to buy page
    $('[data-tooltip]').hover(function (event) {
        var titleText = $(this).data('tooltip');
        var titleTitle = $(this).data('tooltip-title');
        $(this).data('tipText', titleText);
        $('<div class="tt"><h3></h3><p></p></div>')
            .appendTo('body')
            .css('top', (event.pageY - 50) + 'px')
            .css('left', (event.pageX + 50) + 'px')
            .fadeIn('slow');
        $('.tt h3').text(titleTitle);
        $('.tt p').text(titleText);
    }, function () {
        $('.tt').remove();
    }).mousemove(function (event) {
        $('.tt')
            .css('top', (event.pageY - 50) + 'px')
            .css('left', (event.pageX + 50) + 'px');
    });*/
});

function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");

    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}

function cartDropdownToggle() {
    if (jQuery("#cart-dropdown").hasClass("active")) {
        //when hover cart do not hide
        dropdownHover = setInterval(function () {
            var $dropdown = jQuery("#cart-dropdown");
            if ($dropdown.is(":hover")) {
            } else {
                jQuery(".cart-menu-item .shop-button").removeClass("active");
                jQuery("#cart-dropdown").removeClass("active");
                clearInterval(dropdownHover);
            }
        }, 200);
    } else {
        jQuery(".cart-menu-item .shop-button").toggleClass("active");
        jQuery("#cart-dropdown").toggleClass("active");
    }
}

if (jQuery(".main-nav-button").length >= 0) {
    jQuery(".main-nav-button").click(function () {
        jQuery(".logo").toggleClass("active");
    });
}

//youtube settings for homepage video
var player;

// Elements
const cardelement = document.querySelectorAll(".home-category-block")

// Zoom out (press) effect for home-category-block elements
cardelement.forEach((block) => {
    let scaleAnimation = null;

    block.addEventListener('mouseenter', () => {
        // Stop any existing animation
        if (scaleAnimation) {
            scaleAnimation.stop();
        }

        // Scale down slightly for pressed button effect
        scaleAnimation = animate(block,
            {
                scale: 0.95
            },
            {
                duration: 0.2,
                easing: 'easeOut'
            }
        );
    });

    block.addEventListener('mouseleave', () => {
        // Stop any running animation
        if (scaleAnimation) {
            scaleAnimation.stop();
        }

        // Reset to original scale
        animate(block,
            {
                scale: 1
            },
            {
                duration: 0.3,
                easing: 'easeOut'
            }
        );
    });
});

// Scroll-based falling and rotation effect for thumble-image elements
const imageelement = document.querySelectorAll(".thumble-image img");

// Configuration array for thumble-image animations
// You can manually set values for each image here
// If there are more images than entries in this array, it will cycle through the array
// If there are fewer images, only the first N entries will be used
// 
// Value ranges (as currently set):
// - leftPercent: -10 to 95 (percentage, horizontal position)
// - top: -400 to 400 (pixels, vertical position)
// - scale: 0.25 to 1.0 (scale factor for depth effect)
// - rotationSpeed: 0.1 to 0.3 (rotation speed multiplier)
// - fallSpeedMultiplier: 0.5 to 2.0 (fall speed multiplier, 1.0 = normal speed)
const thumbleImageConfig = [
    {
        leftPercent: -10,    // Evenly spaced: position 1 of 6
        top: -287,           // range: -400 to 400
        scale: 1,         // range: 0.25 to 1.0
        rotationSpeed: 0.18, // range: 0.1 to 0.3
        fallSpeedMultiplier: 1.3 // range: 0.5 to 2.0
    },
    {
        leftPercent: 11,     // Evenly spaced: position 2 of 6
        top: 156,
        scale: 1,
        rotationSpeed: 0.24,
        fallSpeedMultiplier: 0.7
    },
    {
        leftPercent: 32,     // Evenly spaced: position 3 of 6
        top: -189,
        scale: 1,
        rotationSpeed: 0.12,
        fallSpeedMultiplier: 0.8
    },
    {
        leftPercent: 53,     // Evenly spaced: position 4 of 6
        top: 342,
        scale: 1,
        rotationSpeed: 0.27,
        fallSpeedMultiplier: 0.9
    },
    {
        leftPercent: 74,     // Evenly spaced: position 5 of 6
        top: -200,
        scale: 1,
        rotationSpeed: 0.15,
        fallSpeedMultiplier: 1
    },
    {
        leftPercent: 86,     // Evenly spaced: position 6 of 6
        top: 178,
        scale: 1,
        rotationSpeed: 0.21,
        fallSpeedMultiplier: 0.8
    }
];

function initFallingBottlesEffect() {
    let scrollFallAnimations = new Map();
    let imageData = new Map();

    // Store visibility state per parent container to maintain consistency
    const visibilityState = new Map();

    // Function to show/hide images based on viewport width
    function updateImageVisibility() {
        const viewportWidth = window.innerWidth;
        let showPercentage = 1.0; // Show all images by default

        if (viewportWidth < 767) {
            showPercentage = 0.5; // Show 50% of images
        } else if (viewportWidth < 1200) {
            showPercentage = 0.75; // Show 75% of images
        }

        // Group images by parent container
        const imagesByParent = new Map();
        imageelement.forEach((img) => {
            const parentContainer = img.closest('.thumble-images');
            if (!imagesByParent.has(parentContainer)) {
                imagesByParent.set(parentContainer, []);
            }
            imagesByParent.get(parentContainer).push(img);
        });

        // For each parent container, show/hide images
        imagesByParent.forEach((images, parentContainer) => {
            const totalImages = images.length;
            const imagesToShow = Math.ceil(totalImages * showPercentage);

            // Get or create visibility state for this parent container
            if (!visibilityState.has(parentContainer)) {
                // First time: create shuffled indices and store them
                const indices = Array.from({ length: totalImages }, (_, i) => i);
                // Shuffle array using Fisher-Yates algorithm
                for (let i = indices.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [indices[i], indices[j]] = [indices[j], indices[i]];
                }
                visibilityState.set(parentContainer, indices);
            }

            const visibleIndices = visibilityState.get(parentContainer);

            // Show selected images, hide others
            images.forEach((img, index) => {
                const imageWrapper = img.closest('.thumble-image');
                if (imageWrapper) {
                    // Check if this image's index is in the first N visible indices
                    if (visibleIndices.indexOf(index) < imagesToShow) {
                        imageWrapper.style.display = '';
                    } else {
                        imageWrapper.style.display = 'none';
                    }
                }
            });
        });
    }

    // Function to initialize image positions
    function initializeImagePositions() {
        // Group images by their parent container
        const imagesByParent = new Map();
        imageelement.forEach((img) => {
            const parentContainer = img.closest('.thumble-images');
            if (!imagesByParent.has(parentContainer)) {
                imagesByParent.set(parentContainer, []);
            }
            imagesByParent.get(parentContainer).push(img);
        });

        // Initialize each parent container's images
        imagesByParent.forEach((images, parentContainer) => {
            const parentRect = parentContainer.getBoundingClientRect();
            const parentWidth = parentRect.width;
            const parentHeight = parentRect.height;
            const parentTop = parentRect.top + window.pageYOffset;
            const totalImages = images.length;

            // Create a shuffled array of config indices for random assignment
            // This ensures each image gets a random config entry, not based on HTML order
            const configIndices = [];
            for (let i = 0; i < totalImages; i++) {
                // Cycle through config array indices, but shuffle the order
                configIndices.push(i % thumbleImageConfig.length);
            }
            // Shuffle the config indices using Fisher-Yates algorithm
            for (let i = configIndices.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [configIndices[i], configIndices[j]] = [configIndices[j], configIndices[i]];
            }

            // Calculate spacing to distribute images evenly
            // Divide horizontal space into segments with some overlap allowed
            const horizontalRange = 105; // -10% to 95% = 105% range
            const segmentWidth = horizontalRange / totalImages;
            const yRange = 400; // -400px to +400px

            images.forEach((img, index) => {
                scrollFallAnimations.set(img, null);
                const imageWrapper = img.closest('.thumble-image');

                if (imageWrapper) {
                    // Force a reflow to ensure accurate height calculation
                    void imageWrapper.offsetHeight;

                    // Use wrapper height for stacking, fallback to image height
                    const wrapperHeight = imageWrapper.offsetHeight || img.offsetHeight || img.naturalHeight || 200;
                    const wrapperWidth = imageWrapper.offsetWidth || img.offsetWidth || 200;

                    // Get configuration for this image (randomly assigned from shuffled array)
                    const configIndex = configIndices[index];
                    const config = thumbleImageConfig[configIndex];

                    // Calculate left position: use config value or generate random
                    let clampedLeftPercent;
                    if (config.leftPercent !== null && config.leftPercent !== undefined) {
                        clampedLeftPercent = Math.max(-10, Math.min(95, config.leftPercent));
                    } else {
                        // Distribute X position evenly across segments with minimal randomness
                        // Each image gets a segment, positioned more strictly
                        const segmentStart = (index * segmentWidth) - 10; // Start at -10%
                        // Use center of segment with very small randomness (10% of segment width)
                        const segmentRandomness = segmentWidth * 0.1;
                        const randomLeftPercent = segmentStart + (segmentWidth * 0.5) + ((Math.random() - 0.5) * segmentRandomness);
                        // Clamp to the overall range
                        clampedLeftPercent = Math.max(-10, Math.min(95, randomLeftPercent));
                    }

                    // Calculate top position: use config value or generate random
                    let clampedTop;
                    if (config.top !== null && config.top !== undefined) {
                        clampedTop = Math.max(-yRange, Math.min(yRange, config.top));
                    } else {
                        // Distribute Y position evenly with minimal randomness
                        // Divide vertical space into segments
                        const verticalSegmentHeight = (yRange * 2) / totalImages;
                        const segmentYStart = -yRange + (index * verticalSegmentHeight);
                        // Use center of segment with very small randomness (15% of segment height)
                        const segmentYRandomness = verticalSegmentHeight * 0.15;
                        const randomTop = segmentYStart + (verticalSegmentHeight * 0.5) + ((Math.random() - 0.5) * segmentYRandomness);
                        // Clamp to the overall range
                        clampedTop = Math.max(-yRange, Math.min(yRange, randomTop));
                    }

                    // Set evenly distributed positions - this is the base position
                    imageWrapper.style.left = clampedLeftPercent + '%';
                    imageWrapper.style.top = clampedTop + 'px';

                    // Calculate translateY independently of top position
                    // translateY adds fixed movement regardless of where top is set
                    const extraFallDistance = 600;
                    // Start: move up by parent height to ensure all images start above parent
                    // End: move down by parent height + 400px to ensure all end 400px beyond bottom
                    const startTranslateY = -parentHeight;
                    const endTranslateY = parentHeight + extraFallDistance;

                    // Get rotation speed: use config value or generate random
                    let rotationSpeed;
                    if (config.rotationSpeed !== null && config.rotationSpeed !== undefined) {
                        rotationSpeed = Math.max(0.1, Math.min(0.3, config.rotationSpeed));
                    } else {
                        // Generate random rotation speed for each image
                        // Minimum: 0.1 (current level), Maximum: 0.3 (3x the current)
                        const minRotationSpeed = 0.1;
                        const maxRotationSpeed = 0.3;
                        rotationSpeed = minRotationSpeed + (Math.random() * (maxRotationSpeed - minRotationSpeed));
                    }

                    // Get scale: use config value or generate random
                    let randomScale;
                    if (config.scale !== null && config.scale !== undefined) {
                        randomScale = Math.max(0.25, Math.min(1.0, config.scale));
                    } else {
                        // Generate random scale for depth effect
                        // Scale between 0.25 (25%) and 1.0 (100%) of current width
                        const minScale = 0.25;
                        const maxScale = 1.0;
                        randomScale = minScale + (Math.random() * (maxScale - minScale));
                    }

                    // Set z-index based on scale - larger images appear in front
                    // Convert scale (0.25-1.0) to z-index (1-100)
                    const zIndex = Math.round(randomScale * 100);
                    imageWrapper.style.zIndex = zIndex;

                    // Set transform origin for proper scaling and apply initial scale
                    img.style.transformOrigin = 'center center';
                    img.style.transform = `scale(${randomScale})`;

                    // Get fall speed multiplier: use config value or generate random
                    let fallSpeedMultiplier;
                    if (config.fallSpeedMultiplier !== null && config.fallSpeedMultiplier !== undefined) {
                        fallSpeedMultiplier = Math.max(0.5, Math.min(2.0, config.fallSpeedMultiplier));
                    } else {
                        // Generate random fall speed multiplier
                        // Range: 0.5 (50% slower) to 2.0 (100% faster)
                        const minFallSpeed = 0.5;
                        const maxFallSpeed = 2;
                        fallSpeedMultiplier = minFallSpeed + (Math.random() * (maxFallSpeed - minFallSpeed));
                    }

                    // Store initial data for each image
                    imageData.set(img, {
                        parentContainer: parentContainer,
                        parentTop: parentTop,
                        parentHeight: parentHeight,
                        startTranslateY: startTranslateY, // translateY start value
                        endTranslateY: endTranslateY, // translateY end value
                        wrapperTop: clampedTop, // Store the CSS top value (base position, -400 to +400)
                        wrapperLeft: clampedLeftPercent, // Store the CSS left value as percentage
                        rotationSpeed: rotationSpeed, // Store individual rotation speed
                        imageScale: randomScale, // Store the scale value for depth
                        fallSpeedMultiplier: fallSpeedMultiplier, // Store fall speed multiplier
                        wrapperHeight: wrapperHeight,
                        wrapperWidth: wrapperWidth,
                        configIndex: configIndex // Store which config entry was used for this image
                    });
                }
            });
        });
    }

    // Wait for all images to load before initializing positions
    let imagesLoaded = 0;
    const totalImages = imageelement.length;

    imageelement.forEach((img) => {
        if (img.complete) {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
                initializeImagePositions();
                updateImageVisibility();
                updateScrollFall();
            }
        } else {
            img.addEventListener('load', () => {
                imagesLoaded++;
                if (imagesLoaded === totalImages) {
                    initializeImagePositions();
                    updateImageVisibility();
                    updateScrollFall();
                }
            });
            img.addEventListener('error', () => {
                imagesLoaded++;
                if (imagesLoaded === totalImages) {
                    initializeImagePositions();
                    updateImageVisibility();
                    updateScrollFall();
                }
            });
        }
    });

    // Fallback: initialize after a short delay if images don't load
    setTimeout(() => {
        if (imageData.size === 0) {
            initializeImagePositions();
            updateImageVisibility();
            updateScrollFall();
        }
    }, 1000);

    // Function to update falling position and rotation based on scroll
    function updateScrollFall() {
        // Use a more stable scroll position reading for mobile momentum scrolling
        const scrollY = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;

        imageelement.forEach((img) => {
            const data = imageData.get(img);
            if (!data) return;

            // Use each image's individual rotation speed
            const rotationSpeed = data.rotationSpeed || 0.1;
            const rotation = scrollY * rotationSpeed;

            const parentRect = data.parentContainer.getBoundingClientRect();
            const currentParentTop = parentRect.top + scrollY;
            const currentParentHeight = parentRect.height;

            // Calculate translateY independently of top position
            // translateY adds fixed movement regardless of where top is set
            const extraFallDistance = 400;
            // Start: move up by parent height to ensure all images start above parent
            // End: move down by parent height + 400px to ensure all end 400px beyond bottom
            const startTranslateY = -currentParentHeight;
            const endTranslateY = currentParentHeight + extraFallDistance;

            // Calculate scroll progress: 0 when parent top enters viewport, 1 when parent is halfway through viewport
            // Reduced scroll range makes bottles fall faster
            const viewportHeight = window.innerHeight;
            const scrollStart = currentParentTop - viewportHeight;
            // Complete animation when parent is halfway through viewport (faster fall)
            const scrollEnd = currentParentTop + (currentParentHeight * 0.5);
            const scrollRange = scrollEnd - scrollStart;

            // Calculate progress (0 to 1) based on scroll position
            let progress = (scrollY - scrollStart) / scrollRange;

            // Apply fall speed multiplier to make some images fall faster or slower
            const fallSpeedMultiplier = data.fallSpeedMultiplier || 1.0;
            progress = progress * fallSpeedMultiplier;

            progress = Math.max(0, Math.min(1, progress)); // Clamp between 0 and 1

            // Interpolate between start and end translateY positions
            const translateY = startTranslateY + (progress * (endTranslateY - startTranslateY));

            // Get the wrapper element
            const imageWrapper = img.closest('.thumble-image');
            if (!imageWrapper) return;

            // Stop previous animations if running
            const prevTranslateAnimation = scrollFallAnimations.get(img);
            if (prevTranslateAnimation) {
                prevTranslateAnimation.stop();
            }

            // Apply translateY to the wrapper (for falling effect)
            // Use longer duration on mobile to smooth out momentum scrolling
            const animationDuration = isMobile() ? 0.3 : 0.1;

            const wrapperAnimation = animate(imageWrapper,
                {
                    y: translateY
                },
                {
                    duration: animationDuration,
                    easing: 'linear'
                }
            );

            // Apply rotation and scale to the img (for spinning effect and depth)
            const imageScale = data.imageScale || 1.0;
            const imgAnimation = animate(img,
                {
                    rotate: rotation,
                    scale: imageScale
                },
                {
                    duration: animationDuration,
                    easing: 'linear'
                }
            );

            // Store wrapper animation for cleanup
            scrollFallAnimations.set(img, wrapperAnimation);
        });
    }

    // Throttle scroll events for better performance
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateScrollFall();
                ticking = false;
            });
            ticking = true;
        }
    }

    // Add scroll event listener
    window.addEventListener('scroll', onScroll, { passive: true });

    // Handle window resize to recalculate positions
    let resizeTicking = false;
    function onResize() {
        if (!resizeTicking) {
            window.requestAnimationFrame(() => {
                // Group images by parent container for recalculation
                const imagesByParent = new Map();
                imageelement.forEach((img) => {
                    const parentContainer = img.closest('.thumble-images');
                    if (!imagesByParent.has(parentContainer)) {
                        imagesByParent.set(parentContainer, []);
                    }
                    imagesByParent.get(parentContainer).push(img);
                });

                // Recalculate evenly distributed positions and parent heights for each parent container
                imagesByParent.forEach((images, parentContainer) => {
                    const parentRect = parentContainer.getBoundingClientRect();
                    const currentParentWidth = parentRect.width;
                    const currentParentHeight = parentRect.height;
                    const totalImages = images.length;

                    // Calculate spacing to distribute images evenly (same as initialization)
                    const horizontalRange = 105; // -10% to 95% = 105% range
                    const segmentWidth = horizontalRange / totalImages;
                    const yRange = 400; // -400px to +400px

                    images.forEach((img, index) => {
                        const data = imageData.get(img);
                        if (!data) return;

                        const imageWrapper = img.closest('.thumble-image');
                        if (imageWrapper) {
                            // Force a reflow to ensure accurate height calculation
                            void imageWrapper.offsetHeight;

                            const wrapperHeight = imageWrapper.offsetHeight || img.offsetHeight || img.naturalHeight || 200;
                            const wrapperWidth = imageWrapper.offsetWidth || img.offsetWidth || 200;

                            // Get configuration for this image (use stored configIndex if available, otherwise use index)
                            const configIndex = (data.configIndex !== undefined) ? data.configIndex : (index % thumbleImageConfig.length);
                            const config = thumbleImageConfig[configIndex];

                            // Calculate left position: use config value or generate random
                            let clampedLeftPercent;
                            if (config.leftPercent !== null && config.leftPercent !== undefined) {
                                clampedLeftPercent = Math.max(-10, Math.min(95, config.leftPercent));
                            } else {
                                // Distribute X position evenly across segments with minimal randomness
                                const segmentStart = (index * segmentWidth) - 10; // Start at -10%
                                // Use center of segment with very small randomness (10% of segment width)
                                const segmentRandomness = segmentWidth * 0.1;
                                const randomLeftPercent = segmentStart + (segmentWidth * 0.5) + ((Math.random() - 0.5) * segmentRandomness);
                                clampedLeftPercent = Math.max(-10, Math.min(95, randomLeftPercent));
                            }

                            // Calculate top position: use config value or generate random
                            let clampedTop;
                            if (config.top !== null && config.top !== undefined) {
                                clampedTop = Math.max(-yRange, Math.min(yRange, config.top));
                            } else {
                                // Distribute Y position evenly with minimal randomness
                                const verticalSegmentHeight = (yRange * 2) / totalImages;
                                const segmentYStart = -yRange + (index * verticalSegmentHeight);
                                // Use center of segment with very small randomness (15% of segment height)
                                const segmentYRandomness = verticalSegmentHeight * 0.15;
                                const randomTop = segmentYStart + (verticalSegmentHeight * 0.5) + ((Math.random() - 0.5) * segmentYRandomness);
                                clampedTop = Math.max(-yRange, Math.min(yRange, randomTop));
                            }

                            // Update evenly distributed positions
                            imageWrapper.style.left = clampedLeftPercent + '%';
                            imageWrapper.style.top = clampedTop + 'px';

                            // Recalculate translateY independently of top position
                            const extraFallDistance = 400;
                            // Start: move up by parent height to ensure all images start above parent
                            // End: move down by parent height + 400px to ensure all end 400px beyond bottom
                            const startTranslateY = -currentParentHeight;
                            const endTranslateY = currentParentHeight + extraFallDistance;

                            // Update stored data
                            data.parentHeight = currentParentHeight;
                            data.startTranslateY = startTranslateY;
                            data.endTranslateY = endTranslateY;
                            data.wrapperTop = clampedTop;
                            data.wrapperLeft = clampedLeftPercent;
                            data.wrapperHeight = wrapperHeight;
                            data.wrapperWidth = wrapperWidth;
                            data.configIndex = configIndex; // Ensure configIndex is stored
                        }
                    });
                });

                // Update visibility and positions after resize
                updateImageVisibility();
                updateScrollFall();
                resizeTicking = false;
            });
            resizeTicking = true;
        }
    }
    window.addEventListener('resize', onResize, { passive: true });

    // Initialize falling position on page load
    updateScrollFall();
}

// Run the falling-bottles effect only when the elements exist.
// Kept inside a function (not a bare top-level block) so its inner helper
// declarations stay function-scoped — a bare block lets the minifier hoist
// them into module scope, where a name can collide with bundled Swiper code.
if (imageelement.length > 0) {
    initFallingBottlesEffect();
}

// Hero animations
document.addEventListener('DOMContentLoaded', function () {
    const heroBlock = document.querySelector('.hero-block');
    const heroInner = heroBlock?.querySelector('.hero-inner');
    const descriptionElement = heroBlock?.querySelector('.fade-in-animation');

    if (!heroBlock || !heroInner) return;

    // Skip scroll animation on mobile
    if (!isMobile()) {
        initHeroScrollShrink(heroBlock, heroInner);
    }

    // Initialize description fade-in
    if (descriptionElement) {
        initDescriptionFadeIn(descriptionElement);
    }
});

// Hero scroll-shrink animation
function initHeroScrollShrink(heroBlock, heroInner) {
    const computedStyle = window.getComputedStyle(heroInner);
    const startWidth = parseFloat(computedStyle.width) || window.innerWidth;
    const startHeight = parseFloat(computedStyle.height) || window.innerHeight;
    const aspectRatio = startWidth / startHeight;

    const targetWidth = getContainerWidth();
    const targetHeight = targetWidth / aspectRatio;
    const targetBorderRadius = 16;
    const scrollDistance = 300;

    // Height accommodates initial 100vh so hero stays sticky during animation
    const totalHeight = scrollDistance + Math.max(startHeight, targetHeight);

    heroBlock.style.height = `${totalHeight}px`;
    heroBlock.style.minHeight = `${totalHeight}px`;

    scroll(
        animate(heroInner, {
            width: [`${startWidth}px`, `${targetWidth}px`],
            height: [`${startHeight}px`, `${targetHeight}px`],
            borderRadius: ['0px', `${targetBorderRadius}px`]
        }, {
            easing: 'easeOut'
        }),
        {
            target: heroBlock,
            offset: ['start start', `${scrollDistance}px start`]
        }
    );

    // Add padding-left animation for style-left variant
    if (heroBlock.classList.contains('style-left')) {
        const heroContentInner = heroBlock.querySelector('.hero-content-inner');
        if (heroContentInner) {
            const startMargin = parseFloat(getComputedStyle(heroContentInner).marginLeft) || 0;
            const targetMargin = startMargin + 30;

            scroll(
                animate(heroContentInner, {
                    marginLeft: [`${startMargin}px`, `${targetMargin}px`]
                }, {
                    easing: 'easeOut'
                }),
                {
                    target: heroBlock,
                    offset: ['start start', `${scrollDistance}px start`]
                }
            );
        }
    }

    // Recalculate on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (isMobile()) return;

            const newStyle = window.getComputedStyle(heroInner);
            const newStartHeight = parseFloat(newStyle.height) || window.innerHeight;
            const newStartWidth = parseFloat(newStyle.width) || window.innerWidth;
            const newTargetWidth = getContainerWidth();
            const newTargetHeight = newTargetWidth / (newStartWidth / newStartHeight);
            const newTotalHeight = scrollDistance + Math.max(newStartHeight, newTargetHeight);

            heroBlock.style.height = `${newTotalHeight}px`;
            heroBlock.style.minHeight = `${newTotalHeight}px`;
        }, 100);
    }, { passive: true });
}

// Description fade-in animation
function initDescriptionFadeIn(descriptionElement) {
    // Measure natural height
    descriptionElement.style.height = 'auto';
    descriptionElement.style.opacity = '1';
    const naturalHeight = descriptionElement.scrollHeight;
    const padding = 16;

    // Set initial hidden state
    descriptionElement.style.height = '0';
    descriptionElement.style.opacity = '0';
    descriptionElement.style.overflow = 'hidden';
    descriptionElement.style.paddingTop = '0';
    descriptionElement.style.paddingBottom = '0';

    // On mobile, show immediately
    if (isMobile()) {
        descriptionElement.style.height = 'auto';
        descriptionElement.style.opacity = '1';
        descriptionElement.style.overflow = 'visible';
        descriptionElement.style.paddingTop = '8px';
        descriptionElement.style.paddingBottom = '8px';
        return;
    }

    // Fade in after 1 second
    setTimeout(() => {
        animate(descriptionElement, {
            height: naturalHeight + padding + 'px',
            paddingTop: '8px',
            paddingBottom: '8px',
            opacity: 1
        }, {
            duration: 0.3,
            easing: 'easeOut',
            onComplete: () => {
                descriptionElement.style.height = 'auto';
                descriptionElement.style.overflow = 'visible';
            }
        });
    }, 1000);
}